export default {
  FINISHED: 'finished',
  RESERVED: 'reserved'
}
